const angular = require('angular');
const app = angular.module('learn-directives');

app.directive('surveyPopup', ['Application', 'Authorization', 'Surveys', 'SurveyHelper', '$translate', function(Application, Authorization, Surveys, SurveyHelper, $translate) {
    return {
      restrict: 'E',
      replace: false,
      scope: {
        surveyId: '=',
        contentId: '<',
        contentType: '@',
        expandSurvey: '=',
        recordView: '='
      },
      template: require('../../templates/directives/survey-popup.html'),
      controllerAs: 'surveyPopup',
      controller: ['$scope', function ($scope) {
          var self = this;
          self.userLanguage = SurveyHelper.getSurveyjsLanguage(Authorization.getAuthToken().user.language);
          self.loading = true;
          self.survey = {
            title: '',
            description: '',
            pages: [],
            archived: false,
            privacy_collaborators: []
          };
          
          self.openedPopup = false;
          self.recordView = async () => {
            if ($scope.recordView) {
              $scope.recordView();
            }
            self.openedPopup = true;
          }
          
          self.getOne = async () => {
            try {
              const survey = await Surveys.get({subresource: $scope.surveyId}).$promise;
              self.survey = survey;
              self.loading = false;
            } catch (e) {
              console.error('Error retrieving survey: ', e);
            }
          };

          self.complete = async (responses) => {
            // responses format:
            // {
            //   question1: 'answer',
            //   question2: 'answer'
            // }
            const body = SurveyHelper.constructSubmissionBody(
              responses,
              self.questionsByName,
              $scope.surveyId,
              $scope.contentId,
              $scope.contentType,
            );
            body.date_completed = new Date();
            try {
              await SurveyHelper.submitSurveyResults(body);
              Application.messaging.addMessage({type: 'success', duration: 5, text: self.translations["overviewSurvey.submittedSurvey"]});
            } catch (e) {
              Application.messaging.addMessage({type: 'error', duration: 5, text: self.translations["overviewSurvey.submittedSurveyError"]});
            }
            $scope.$apply();
          };
        
          self.init = async () => {
            if (!$scope.surveyId) {
              return;
            }
            await self.getOne();
            self.companyBranding = {
              colors: Application.COLORS,
              font: Application.CUSTOMFONT
            };
            self.questionsByName = SurveyHelper.constructQuestionsByName(self.survey.survey_json.pages, self.survey.questions);
            $scope.$apply();
          };
        

          $translate([
            "overviewSurvey.submittedSurveyError",
            "overviewSurvey.submittedSurvey"
          ]).then(async function(translations) {
            self.translations = translations;
            self.init();
          });
        }
      ]
    };
  }
]);